import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const paths = [
    {path: '/', title: 'Aplikacja SRK'},
    {path: '/regulaminSerwisu', title: 'Regulamin - Aplikacja SRK'},
    {path: '/privacypolicy', title: 'Polityka prywatności - Aplikacja SRK'},
    {path: '/mapa-strony', title: 'Mapa strony - Aplikacja SRK'},
    {path: '/auth/login', title: 'Logowanie - Aplikacja SRK'},
    {path: '/auth/register', title: 'Rejestracja - Aplikacja SRK'},
    {path: '/admin/main_page', title: 'Admin - Aplikacja SRK'},
    {path: '/admin/import_five_four', title: 'Import słowników - Wprowadzenie danych - Aplikacja SRK'},
    {path: '/admin/opk_edit', title: 'Edycja słowników - Wprowadzenie danych - Aplikacja SRK'},
    {path: '/admin/data_import', title: 'Import danych - Wprowadzenie danych - Aplikacja SRK'},
    {path: '/admin/calculate_data', title: 'Rozliczanie kosztów - Wprowadzenie danych - Aplikacja SRK'},
    {path: '/admin/pricing_definition', title: 'Definicje - Wycena procedur medycznych - Aplikacja SRK'},
    {path: '/admin/pricing_med', title: 'Wycena procedur medycznych - Aplikacja SRK'},
    {path: '/admin/raport', title: 'Raporty - Aplikacja SRK'},
    {path: '/admin/management_dashboard', title: 'Pulpit zarządczy - Aplikacja SRK'},
    {path: '/admin/yourData', title: 'Twoje sprawozdanie finansowe - Wskźniki - Aplikacja SRK'},
    {path: '/admin/my_indicators', title: 'Moje wskaźniki - Wskźniki - Aplikacja SRK'},
    {path: '/admin/comperative_indicators', title: 'Benchmarking - Wskźniki - Aplikacja SRK'},
    {path: '/admin/profile', title: 'Profil użytkownika - Aplikacja SRK'},
]

const useDocumentTitle = () => {
    const location = useLocation();
    useEffect(() => {
        const filteredPath = paths?.find((e) => e.path === location.pathname);
        if (filteredPath) {
            const { title } = filteredPath;
                document.title = title;
        }
    }, [location.pathname])
}


export default useDocumentTitle;